import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeleteFaceModal({ open, onClose, onConfirmDelete }) {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{`Are you SURE to delete this person from contacts?`}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            This action is not recoverable. Upon clicking 'Confirm', this face will remain in the system but recognized as unknown faces.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} style={{color: 'gray'}}>
            Cancel
          </Button>
          <Button onClick={onConfirmDelete} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
